module.exports = __webpack_public_path__ + "img/ovaltine.93704d46.jpg";